import { useState, useEffect } from "react"
import axiosWithAuth from "../../utils/axiosWithAuth"

import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

function StockoutForm({ stockoutList, setStockoutList, stockinList }) {
  const [ stockoutid, setStockoutid ] = useState("")  

  const fetchStockoutList = async () => {
    await axiosWithAuth().get("/stock/in-stock")
      .then(res => {
        return setStockoutList(res.data)
      })
      .catch(() => {
        return toast("Something went wrong fetching in-stock list")
      })
  }

  useEffect(() => {
    return fetchStockoutList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ stockinList ])

  const handleStockoutChange = e => {
    return setStockoutid(e.target.value)
  }
  
  const handleStockoutSubmit = async e => {
    e.preventDefault()
    
    await axiosWithAuth().put(`/stock/stockout/${stockoutid}`)
      .then(() => {
        return fetchStockoutList()
      })
      .catch(() => {
        return toast("Something went wrong setting 'Out of Stock'")
      })
  }

  return (
    <>
      <form className="sm-stockout-form">
        <label className="sm-stockout-label">Set Out of Stock</label>
        <select className="sm-stockout-dropdown" type="dropdown" onChange={handleStockoutChange}>

          <option value="">- Select an item -</option>

          <option disabled>--------------- Appetizers ---------------</option>
          {stockoutList.length > 0 ?
            stockoutList.map(item => (
              item.unit === "Appetizer" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Deli Sub ---------------</option>
          {stockoutList.length > 0 ?
            stockoutList.map(item => (
              item.unit === "Deli Sub" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Hot Sub ---------------</option>
          {stockoutList.length > 0 ?
            stockoutList.map(item => (
              item.unit === "Hot Sub" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Salad ---------------</option>
          {stockoutList.length > 0 ?
            stockoutList.map(item => (
              item.unit === "Salad" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Calzone ---------------</option>
          {stockoutList.length > 0 ?
            stockoutList.map(item => (
              item.unit === "Calzone" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Dinner ---------------</option>
          {stockoutList.length > 0 ?
            stockoutList.map(item => (
              item.unit === "Dinner" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Pizza ---------------</option>
          {stockoutList.length > 0 ?
            stockoutList.map(item => (
              item.unit === "Pizza" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

        </select>     
        <button className="ad-tool" onClick={handleStockoutSubmit}>Submit</button>       
      </form>
    </>
  )
}

export default StockoutForm
